import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY, BUTTON_ACTION_HEIGHT } from 'common/constants';
import { SIZE, LAYERS } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';
import { MainContainer, SuggestLabel } from 'components/SearchableDropdown/styles';
import { ListItemContent } from 'components/ListEditor/styles';
import { InputContainer } from 'components/InputIcon/styles';
import { SearchInput } from 'components/SearchBox/styles';
import { BUTTON_PRIMARY } from 'components/TCButton/styles';

export const ImagesList = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;	
`

export const MessageDiv = styled.div`
    display: flex;
    flex-direction: row;
`

export const SubText = styled.div`
    margin: ${SIZE.HALF + SIZE.QUART}px 0 ${SIZE.QUART}px ${SIZE.ONE}px;
    flex-grow: 0;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    color: #bdbdbd;
`

export const GeneralContainer = styled.div`
    display: flex;
    flex-flow: column;
    flex: 1;
    ${MainContainer} {
        height: unset;
    }
    ${ListItemContent} {
        padding: 0;
    }
    ${InputContainer} {
        box-shadow: none;
    }
`

export const IconContainer = styled.div`    
    display: flex;     
    justify-content: center;
    width:35px;   
`

export const InputTextarea = styled.textarea`
    display: flex;
    flex: 1;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    outline: none;
    border:none;
    min-height: ${SIZE.FIFTEEN}px; 
    color: #3D3D3D;
`

export const ViewLabel = styled.span`
    display:flex;
    flex-direction: column;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #000;
    white-space: pre-wrap;
`

export const Input = styled.input`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    color: #343434;
    outline: none;
    border: none;
    padding: ${SIZE.ONE}px 0;
    flex:1;
`

export const DateFieldWrapper = styled.div`
    display:flex;
    padding: ${SIZE.ONE}px;
`

export interface IconWrapperProps {
    width?: string
    height?: string
}
export const IconWrapper = styled.div`
    display: flex;
    &: hover {
        cursor: pointer;
    }
`


export const ActionContainer = styled.div`
    display:flex;
    flex: 1;
    margin: ${SIZE.TWO}px ${SIZE.ONE}px;
    &:hover {
        cursor: pointer;
        transform: scale(1.2);
    }
    transition: all 0.300s;
    width:25px;
`;


export const CategoryPicker = styled.input`
    border-radius: 5px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);
    background-color: #ffffff;
    position: relative;
    flex:unset;
    font-family: ${DEFAULT_FONT_FAMILY};
    padding: ${SIZE.ONE}px ${SIZE.TWO}px ${SIZE.ONE}px ${SIZE.TWO}px;
    height: ${BUTTON_ACTION_HEIGHT};

    ::placeholder {
        margin: 0 4.7px 0 0;
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: rgba(112, 112, 112, 0.5);
    }
`

//View Images

export const ViewImagesContainer = styled.div`
    display:flex;
    flex-flow: column;
    margin: 13px 0px 0px 0px;
`

export const ViewImageSection = styled.div`
    display:flex;
    flex-flow: column;
    margin: ${SIZE.ONE}px 0 ${SIZE.ONE}px;
`

export const ViewImageSubtitle = styled.div`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    text-align: left;
    color: #000;
    margin: ${SIZE.ONE} px;
    margin-left: 0;
    width: ${SIZE.TEN}px;
    white-space: nowrap;
`

export const ViewImagesList = styled(LIST)`
    display:flex;
    margin: 0;
`

export const ViewImagesLabel = styled(Label)`
    display:flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    padding: 0 0 ${SIZE.HALF}px 0 ;
    color: #333;
`


export const Row = styled.div`
    display: flex;
    flex-direction: row;
`

export const Column = styled.div`
    display: flex;
    flex-direction: Column;
`

export const AddMore = styled(ViewImageSubtitle)`
    margin: ${SIZE.THREE}px 0;
    color: #ff7319;
    &: hover {
        cursor: pointer;
    }
`

export const ImageBox = styled.div`
    width:${SIZE.SEVEN}px;
    height: ${BUTTON_ACTION_HEIGHT};
    flex-grow: 0;
    margin: ${SIZE.HALF}px ${SIZE.HALF}px 0px 0px;
    padding: ${SIZE.ONE}px ${SIZE.ONE}px ${SIZE.ONE}px ${SIZE.ONE}px;
    border-radius: ${SIZE.HALF}px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);
    background-color: #ffffff;
`



export const CategorySearch = styled.div`
    margin: ${SIZE.HALF}px ${SIZE.HALF}px 0px 0px;
    position: relative;
    display: flex;
    padding: 0px;
    
    
`

//View Images
export const ImageContainer = styled.div`
    display: flex;    
    margin-bottom:${SIZE.ONE}px;
`

export const Image = styled.img`
    display: flex;
    width:${SIZE.SEVEN}px;
    height:${SIZE.FOUR}px;
    border-radius:3px;
    object-fit: cover;
`

export const ImageCategory = styled.div`
    display: flex;    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    text-align: left;
    padding: ${SIZE.ONE}px 0 0 ${SIZE.ONE}px;
`

//DRAWER

export const DrawerContainer = styled.div`
    position: absolute;
    top: ${SIZE.SEVEN}px;

    width: ${SIZE.TWENTYFIVE}px;
    height: 434px;
    padding: 14px 0px 16px 0px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(130, 130, 130, 0.5);

    z-index: ${LAYERS.LAYER_4};
    display: flex;
    flex-flow: column;
    
    max-height: ${SIZE.NINETEEN}px;
    background: white;

    border-radius: ${SIZE.HALF}px;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: ${SIZE.ONE}px;

`

export const DrawerOptionsContainer = styled.div`
    background: white;
    display:flex;
    flex:1;
    overflow: auto;
`

export const DrawerList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-flow: column;
    flex:1;
    overflow: auto;

    ${SearchInput} {
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
    }
`
export interface DrawerListItemProps {
    highlighted: boolean
}

export const DrawerListItem = styled.li`
    height: ${SIZE.FOUR}px;
    display:flex;
    // padding:${SIZE.ONE}px;
    align-items: center;
    &:hover {
        cursor: pointer;
    };
    background: ${(props: DrawerListItemProps) => props.highlighted ? '#DADADA' : 'none'};
`
export const DrawerItemLabel = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    overflow:hidden;
    white-space:nowrap;
    color: #373f53;
    // margin: 0 ${SIZE.HALF}px 0 ${SIZE.HALF}px;
`

export const ImageErrorContainer = styled.div`
    margin: 20px 0px 0px 0px;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #f46969;
`

export const ImageErrorList = styled.ul`
    margin: 2px 0px 2px 0px;
`

export const Information = styled.div`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    margin: 8px 0px 8px 0px;
`
export const BtnUpgrade = styled.div`
    width: 129px;
    height: 36px;
    flex-grow: 0;
  margin: 17px 107px 0 109.5px;
  padding: 9px 17px 10px 19px;
  border: solid 1px #4da0ff;
  background-color: #4da0ff;   
`

export const ImageLock = styled.div`
    

    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #272727;
    background-color: #112240;

    font-family: ${DEFAULT_FONT_FAMILY};;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #fff;
    margin: 17px 8.7px 0.1px 74px;
    padding: 17px 19px 16px 16.5px;    

`


export const ToolTipContainer = styled.div`    
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding:${SIZE.TWO}px;
    min-width: ${SIZE.FORTY}px;
    ${BUTTON_PRIMARY}{
        width: ${SIZE.SEVENTEEN}px;
        height: ${SIZE.FIVE}px;
        flex-grow: 0;        
        padding: 10px;
        border: solid 1px #4da0ff;
        background-color: #4da0ff;
        border-radius: 3px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: left;
        color: #ffffff;
    }
    
`

export const ToolTipText = styled.div`    
    display: flex;
    margin-bottom: ${SIZE.FOUR}px;
    flex-flow: column;
    align-items: center;
    justify-content: center;    
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #ffff;
    word-wrap: normal;
    white-space: pre-wrap;
`
